import { PORTFOLIO_ADMIN_CONSTANTS as C } from '../../_Shared/_MODULES/PortfolioAdminApi';
export const EXPERIENCE_ADMIN_API = { LIST: C.EXPERIENCE_LIST, SAVE: C.EXPERIENCE_SAVE, REMOVE: C.EXPERIENCE_REMOVE };
